// extracted by mini-css-extract-plugin
export default {"imageContainer":"BY-z","summaryPar":"CY-z","ratingCategories":"DY-z","reviewerInfo":"EY-z","reviewTypes":"FY-z","expanded":"GY-z"};